import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

class SpellingDialogPortal extends React.PureComponent {
  el = document.createElement('div');

  parent = document.getElementById('root');

  componentDidMount() {
    if (this.parent) {
      this.parent.appendChild(this.el);
    }

    this.setSpellingDialogPosition();

    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    if (this.parent) {
      this.parent.removeChild(this.el);
    }

    window.removeEventListener('resize', this.handleWindowResize);
  }

  setSpellingDialogPosition = () => {
    const { left, top } = this.props.spellingNode.getBoundingClientRect();

    this.el.style.position = 'absolute';
    this.el.style.left = `${left + window.pageXOffset}px`;
    this.el.style.top = `${top + window.pageYOffset + 25}px`;
    this.el.style.zIndex = 700;
  }

  handleWindowResize = () => {
    this.setSpellingDialogPosition();
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el
    );
  }
}

SpellingDialogPortal.propTypes = {
  children: PropTypes.node,
  spellingNode: PropTypes.object,
};

export default SpellingDialogPortal;
